import React from 'react';

interface ExportCSVProps {
  data: Array<Record<string, any>>; // Array of objects representing rows
  columns: Array<{ key: string; label: string }>; // Array of column definitions
  fileName?: string; // Optional file name
}

const ExportCSV: React.FC<ExportCSVProps> = ({ data, columns, fileName = 'export.csv' }) => {
  const handleExport = () => {
    const csvContent = generateCSVContent();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const generateCSVContent = () => {
    const headers = columns.map((col) => col.label).join(',');
    const rows = data
      .map((row) =>
        columns
          .map((col) => {
            const cell = row[col.key];
            return typeof cell === 'string' ? `"${cell.replace(/"/g, '""')}"` : cell; // Escape double quotes
          })
          .join(',')
      )
      .join('\n');
    return `${headers}\n${rows}`;
  };

  return (
    <button
      onClick={handleExport}
      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
    >
      Export CSV
    </button>
  );
};

export default ExportCSV;
